module.exports = __webpack_public_path__ + "static/iso-certificate-68defb15c9eb4bc0721475d6123a6de7.jpg";